// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
} from '@hey-api/client-fetch'
import type {
  RegisterUserApiAuthRegisterPostData,
  RegisterUserApiAuthRegisterPostResponse,
  RegisterUserApiAuthRegisterPostError,
  LoginUserApiAuthLoginPostData,
  LoginUserApiAuthLoginPostResponse,
  LoginUserApiAuthLoginPostError,
  RequestPasswordResetApiAuthPasswordResetPostData,
  RequestPasswordResetApiAuthPasswordResetPostResponse,
  RequestPasswordResetApiAuthPasswordResetPostError,
  ConfirmPasswordResetApiAuthPasswordResetConfirmPostData,
  ConfirmPasswordResetApiAuthPasswordResetConfirmPostResponse,
  ConfirmPasswordResetApiAuthPasswordResetConfirmPostError,
  RequestEmailVerificationApiAuthVerifyEmailPostData,
  RequestEmailVerificationApiAuthVerifyEmailPostResponse,
  RequestEmailVerificationApiAuthVerifyEmailPostError,
  GetItemsApiItemsGetData,
  GetItemsApiItemsGetResponse,
  GetItemsApiItemsGetError,
  GetItemCategoriesApiItemsCategoriesGetData,
  GetItemCategoriesApiItemsCategoriesGetResponse,
  SearchItemsApiItemsSearchGetData,
  SearchItemsApiItemsSearchGetResponse,
  SearchItemsApiItemsSearchGetError,
  GetItemByIdApiItemsItemIdGetData,
  GetItemByIdApiItemsItemIdGetResponse,
  GetItemByIdApiItemsItemIdGetError,
  GetUserInventoryApiInventoryUserUserIdGetData,
  GetUserInventoryApiInventoryUserUserIdGetResponse,
  GetUserInventoryApiInventoryUserUserIdGetError,
  GetPublicInventoryApiInventoryUserUserIdPublicGetData,
  GetPublicInventoryApiInventoryUserUserIdPublicGetResponse,
  GetPublicInventoryApiInventoryUserUserIdPublicGetError,
  DeleteInventoryItemApiInventoryInventoryIdDeleteData,
  DeleteInventoryItemApiInventoryInventoryIdDeleteResponse,
  DeleteInventoryItemApiInventoryInventoryIdDeleteError,
  GetInventoryItemApiInventoryInventoryIdGetData,
  GetInventoryItemApiInventoryInventoryIdGetResponse,
  GetInventoryItemApiInventoryInventoryIdGetError,
  UpdateInventoryItemApiInventoryInventoryIdPatchData,
  UpdateInventoryItemApiInventoryInventoryIdPatchResponse,
  UpdateInventoryItemApiInventoryInventoryIdPatchError,
  AddInventoryItemApiInventoryPostData,
  AddInventoryItemApiInventoryPostResponse,
  AddInventoryItemApiInventoryPostError,
  HealthCheckApiHealthGetData,
  HealthCheckApiHealthGetResponse,
  GetAllListsApiListsGetData,
  GetAllListsApiListsGetResponse,
  GetAllListsApiListsGetError,
  CreateListApiListsPostData,
  CreateListApiListsPostResponse,
  CreateListApiListsPostError,
  GetUserListsByIdApiListsUserUserIdGetData,
  GetUserListsByIdApiListsUserUserIdGetResponse,
  GetUserListsByIdApiListsUserUserIdGetError,
  DeleteListApiListsListIdDeleteData,
  DeleteListApiListsListIdDeleteResponse,
  DeleteListApiListsListIdDeleteError,
  GetListWithSectionsApiListsListIdGetData,
  GetListWithSectionsApiListsListIdGetResponse,
  GetListWithSectionsApiListsListIdGetError,
  UpdateListApiListsListIdPutData,
  UpdateListApiListsListIdPutResponse,
  UpdateListApiListsListIdPutError,
  DeleteSectionApiListsSectionsSectionIdDeleteData,
  DeleteSectionApiListsSectionsSectionIdDeleteResponse,
  DeleteSectionApiListsSectionsSectionIdDeleteError,
  GetSectionWithItemsApiListsSectionsSectionIdGetData,
  GetSectionWithItemsApiListsSectionsSectionIdGetResponse,
  GetSectionWithItemsApiListsSectionsSectionIdGetError,
  UpdateSectionApiListsSectionsSectionIdPutData,
  UpdateSectionApiListsSectionsSectionIdPutResponse,
  UpdateSectionApiListsSectionsSectionIdPutError,
  CreateSectionApiListsSectionsPostData,
  CreateSectionApiListsSectionsPostResponse,
  CreateSectionApiListsSectionsPostError,
  BulkUpdateListItemsApiListsItemsBulkPutData,
  BulkUpdateListItemsApiListsItemsBulkPutError,
  CreateListItemApiListsItemsPostData,
  CreateListItemApiListsItemsPostResponse,
  CreateListItemApiListsItemsPostError,
  DeleteListItemApiListsItemsItemIdDeleteData,
  DeleteListItemApiListsItemsItemIdDeleteResponse,
  DeleteListItemApiListsItemsItemIdDeleteError,
  UpdateListItemApiListsItemsItemIdPutData,
  UpdateListItemApiListsItemsItemIdPutResponse,
  UpdateListItemApiListsItemsItemIdPutError,
  CreateHighlightKeyApiListsHighlightsPostData,
  CreateHighlightKeyApiListsHighlightsPostResponse,
  CreateHighlightKeyApiListsHighlightsPostError,
  DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteData,
  DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteResponse,
  DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteError,
  UpdateHighlightKeyApiListsHighlightsHighlightIdPutData,
  UpdateHighlightKeyApiListsHighlightsHighlightIdPutResponse,
  UpdateHighlightKeyApiListsHighlightsHighlightIdPutError,
  GetPublicProfilesApiUsersProfilesGetData,
  GetPublicProfilesApiUsersProfilesGetResponse,
  GetPublicProfilesApiUsersProfilesGetError,
  GetPublicProfileApiUsersProfilesUserIdGetData,
  GetPublicProfileApiUsersProfilesUserIdGetResponse,
  GetPublicProfileApiUsersProfilesUserIdGetError,
  GetMyProfileApiUsersMeGetData,
  GetMyProfileApiUsersMeGetResponse,
  UpdateMyProfileApiUsersMePatchData,
  UpdateMyProfileApiUsersMePatchResponse,
  UpdateMyProfileApiUsersMePatchError,
  UploadAvatarApiUsersMeAvatarPostData,
  UploadAvatarApiUsersMeAvatarPostResponse,
} from './types.gen'
import { client as _heyApiClient } from './client.gen'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Register User
 * Register a new user with email and password.
 *
 * This endpoint creates a new user account using Supabase Auth.
 * The user will receive a confirmation email to verify their account.
 */
export const registerUserApiAuthRegisterPost = <ThrowOnError extends boolean = false>(
  options: Options<RegisterUserApiAuthRegisterPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RegisterUserApiAuthRegisterPostResponse,
    RegisterUserApiAuthRegisterPostError,
    ThrowOnError
  >({
    url: '/api/auth/register',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Login User
 * Authenticate a user with email and password.
 *
 * This endpoint verifies user credentials and returns authentication tokens.
 */
export const loginUserApiAuthLoginPost = <ThrowOnError extends boolean = false>(
  options: Options<LoginUserApiAuthLoginPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    LoginUserApiAuthLoginPostResponse,
    LoginUserApiAuthLoginPostError,
    ThrowOnError
  >({
    url: '/api/auth/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Request Password Reset
 * Request a password reset email.
 *
 * This endpoint sends a password reset link to the provided email address.
 * For security reasons, it will always return success even if the email doesn't exist.
 */
export const requestPasswordResetApiAuthPasswordResetPost = <ThrowOnError extends boolean = false>(
  options: Options<RequestPasswordResetApiAuthPasswordResetPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RequestPasswordResetApiAuthPasswordResetPostResponse,
    RequestPasswordResetApiAuthPasswordResetPostError,
    ThrowOnError
  >({
    url: '/api/auth/password-reset',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Confirm Password Reset
 * Reset password using a reset token.
 *
 * This endpoint changes the user's password using the token received in the reset email.
 */
export const confirmPasswordResetApiAuthPasswordResetConfirmPost = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmPasswordResetApiAuthPasswordResetConfirmPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    ConfirmPasswordResetApiAuthPasswordResetConfirmPostResponse,
    ConfirmPasswordResetApiAuthPasswordResetConfirmPostError,
    ThrowOnError
  >({
    url: '/api/auth/password-reset/confirm',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Request Email Verification
 * Request email verification.
 *
 * This endpoint sends a verification email to the provided address.
 * For security reasons, it will always return success even if the email doesn't exist.
 */
export const requestEmailVerificationApiAuthVerifyEmailPost = <ThrowOnError extends boolean = false>(
  options: Options<RequestEmailVerificationApiAuthVerifyEmailPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    RequestEmailVerificationApiAuthVerifyEmailPostResponse,
    RequestEmailVerificationApiAuthVerifyEmailPostError,
    ThrowOnError
  >({
    url: '/api/auth/verify-email',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get Items
 * Get paginated list of all items.
 *
 * Args:
 * page: Page number (starts at 1)
 * page_size: Number of items per page (1-100)
 *
 * Returns:
 * PaginatedItemResponse: Paginated list of items
 */
export const getItemsApiItemsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetItemsApiItemsGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetItemsApiItemsGetResponse, GetItemsApiItemsGetError, ThrowOnError>({
    url: '/api/items/',
    ...options,
  })
}

/**
 * Get Item Categories
 * Get all item categories.
 *
 * Returns:
 * List[ItemCategory]: List of all item categories
 */
export const getItemCategoriesApiItemsCategoriesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetItemCategoriesApiItemsCategoriesGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetItemCategoriesApiItemsCategoriesGetResponse, unknown, ThrowOnError>({
    url: '/api/items/categories',
    ...options,
  })
}

/**
 * Search Items
 * Search for items by name or description.
 *
 * Args:
 * query: Search query text
 * page: Page number (starts at 1)
 * page_size: Number of items per page (1-100)
 *
 * Returns:
 * PaginatedItemResponse: Paginated search results
 */
export const searchItemsApiItemsSearchGet = <ThrowOnError extends boolean = false>(
  options: Options<SearchItemsApiItemsSearchGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    SearchItemsApiItemsSearchGetResponse,
    SearchItemsApiItemsSearchGetError,
    ThrowOnError
  >({
    url: '/api/items/search',
    ...options,
  })
}

/**
 * Get Item By Id
 * Get a specific item by ID.
 *
 * Args:
 * item_id: The item ID
 *
 * Returns:
 * ItemResponse: The item details
 *
 * Raises:
 * ResourceNotFoundError: If the item is not found
 */
export const getItemByIdApiItemsItemIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetItemByIdApiItemsItemIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetItemByIdApiItemsItemIdGetResponse,
    GetItemByIdApiItemsItemIdGetError,
    ThrowOnError
  >({
    url: '/api/items/{item_id}',
    ...options,
  })
}

/**
 * Get a user's inventory
 * Get a user's inventory items with pagination.
 *
 * Args:
 * user_id: The ID of the user whose inventory to retrieve
 * page: Page number (1-indexed)
 * page_size: Number of items per page
 * include_items: Whether to include detailed item information
 *
 * Returns:
 * Paginated list of inventory items
 */
export const getUserInventoryApiInventoryUserUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUserInventoryApiInventoryUserUserIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetUserInventoryApiInventoryUserUserIdGetResponse,
    GetUserInventoryApiInventoryUserUserIdGetError,
    ThrowOnError
  >({
    url: '/api/inventory/user/{user_id}',
    ...options,
  })
}

/**
 * Get a user's public inventory
 * Get a user's public inventory items with pagination.
 *
 * Args:
 * user_id: The ID of the user whose public inventory to retrieve
 * page: Page number (1-indexed)
 * page_size: Number of items per page
 * include_items: Whether to include detailed item information
 *
 * Returns:
 * Paginated list of public inventory items
 */
export const getPublicInventoryApiInventoryUserUserIdPublicGet = <ThrowOnError extends boolean = false>(
  options: Options<GetPublicInventoryApiInventoryUserUserIdPublicGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetPublicInventoryApiInventoryUserUserIdPublicGetResponse,
    GetPublicInventoryApiInventoryUserUserIdPublicGetError,
    ThrowOnError
  >({
    url: '/api/inventory/user/{user_id}/public',
    ...options,
  })
}

/**
 * Delete inventory item
 * Delete an inventory item.
 *
 * Args:
 * inventory_id: The ID of the inventory item to delete
 *
 * Raises:
 * HTTPException: If the inventory item is not found or could not be deleted
 */
export const deleteInventoryItemApiInventoryInventoryIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteInventoryItemApiInventoryInventoryIdDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteInventoryItemApiInventoryInventoryIdDeleteResponse,
    DeleteInventoryItemApiInventoryInventoryIdDeleteError,
    ThrowOnError
  >({
    url: '/api/inventory/{inventory_id}',
    ...options,
  })
}

/**
 * Get inventory item by ID
 * Get a specific inventory item by ID.
 *
 * Args:
 * inventory_id: The ID of the inventory item to retrieve
 * include_item: Whether to include detailed item information
 *
 * Returns:
 * Inventory item details
 *
 * Raises:
 * HTTPException: If the inventory item is not found
 */
export const getInventoryItemApiInventoryInventoryIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetInventoryItemApiInventoryInventoryIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetInventoryItemApiInventoryInventoryIdGetResponse,
    GetInventoryItemApiInventoryInventoryIdGetError,
    ThrowOnError
  >({
    url: '/api/inventory/{inventory_id}',
    ...options,
  })
}

/**
 * Update inventory item
 * Update an inventory item.
 *
 * Args:
 * inventory_id: The ID of the inventory item to update
 * updates: The fields to update
 *
 * Returns:
 * The updated inventory item
 *
 * Raises:
 * HTTPException: If the inventory item is not found or could not be updated
 */
export const updateInventoryItemApiInventoryInventoryIdPatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateInventoryItemApiInventoryInventoryIdPatchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateInventoryItemApiInventoryInventoryIdPatchResponse,
    UpdateInventoryItemApiInventoryInventoryIdPatchError,
    ThrowOnError
  >({
    url: '/api/inventory/{inventory_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Add item to inventory
 * Add an item to a user's inventory.
 *
 * Args:
 * inventory_data: The inventory item data
 *
 * Returns:
 * The created inventory item
 *
 * Raises:
 * HTTPException: If the item could not be added
 */
export const addInventoryItemApiInventoryPost = <ThrowOnError extends boolean = false>(
  options: Options<AddInventoryItemApiInventoryPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    AddInventoryItemApiInventoryPostResponse,
    AddInventoryItemApiInventoryPostError,
    ThrowOnError
  >({
    url: '/api/inventory',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Health Check
 * API health check endpoint.
 */
export const healthCheckApiHealthGet = <ThrowOnError extends boolean = false>(
  options?: Options<HealthCheckApiHealthGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<HealthCheckApiHealthGetResponse, unknown, ThrowOnError>({
    url: '/api/health/',
    ...options,
  })
}

/**
 * Get all lists
 * Get lists for the current user with pagination.
 *
 * Args:
 * page: Page number (1-indexed)
 * page_size: Number of items per page
 * list_type: List type filter
 * sort_by: Sort by option
 * item_ids: Optional comma-separated list of item IDs to filter by
 * current_user: Optional current authenticated user (from dependency)
 *
 * Returns:
 * Paginated list of user lists
 */
export const getAllListsApiListsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetAllListsApiListsGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetAllListsApiListsGetResponse,
    GetAllListsApiListsGetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists',
    ...options,
  })
}

/**
 * Create a list
 * Create a new list for the current user.
 *
 * Args:
 * list_data: The list data
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * The created list
 *
 * Raises:
 * HTTPException: If the list could not be created
 */
export const createListApiListsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateListApiListsPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateListApiListsPostResponse,
    CreateListApiListsPostError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get lists for a specific user
 * Get lists for a specific user with pagination.
 *
 * Args:
 * user_id: The ID of the user whose lists to retrieve
 * page: Page number (1-indexed)
 * page_size: Number of items per page
 * current_user: Optional current authenticated user (from dependency)
 *
 * Returns:
 * Paginated list of user lists
 */
export const getUserListsByIdApiListsUserUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetUserListsByIdApiListsUserUserIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetUserListsByIdApiListsUserUserIdGetResponse,
    GetUserListsByIdApiListsUserUserIdGetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/user/{user_id}',
    ...options,
  })
}

/**
 * Delete a list
 * Delete a list.
 *
 * Args:
 * list_id: The ID of the list to delete
 * current_user: Current authenticated user (from dependency)
 *
 * Raises:
 * HTTPException: If the list is not found or could not be deleted
 */
export const deleteListApiListsListIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteListApiListsListIdDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteListApiListsListIdDeleteResponse,
    DeleteListApiListsListIdDeleteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/{list_id}',
    ...options,
  })
}

/**
 * Get list with sections
 * Get a list with all its sections and highlight keys.
 *
 * Args:
 * list_id: The ID of the list to retrieve
 * current_user: Optional current authenticated user (from dependency)
 *
 * Returns:
 * List with sections and highlight keys
 *
 * Raises:
 * HTTPException: If the list is not found
 */
export const getListWithSectionsApiListsListIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetListWithSectionsApiListsListIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetListWithSectionsApiListsListIdGetResponse,
    GetListWithSectionsApiListsListIdGetError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/{list_id}',
    ...options,
  })
}

/**
 * Update a list
 * Update a list.
 *
 * Args:
 * list_id: The ID of the list to update
 * updates: The fields to update
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * The updated list
 *
 * Raises:
 * HTTPException: If the list is not found or could not be updated
 */
export const updateListApiListsListIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateListApiListsListIdPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateListApiListsListIdPutResponse,
    UpdateListApiListsListIdPutError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/{list_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Delete a section
 * Delete a section.
 *
 * Args:
 * section_id: The ID of the section to delete
 * current_user: Current authenticated user (from dependency)
 *
 * Raises:
 * HTTPException: If the section is not found or could not be deleted
 */
export const deleteSectionApiListsSectionsSectionIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSectionApiListsSectionsSectionIdDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteSectionApiListsSectionsSectionIdDeleteResponse,
    DeleteSectionApiListsSectionsSectionIdDeleteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/sections/{section_id}',
    ...options,
  })
}

/**
 * Get section with items
 * Get a section with all its items.
 *
 * Args:
 * section_id: The ID of the section to retrieve
 *
 * Returns:
 * Section with items
 *
 * Raises:
 * HTTPException: If the section is not found
 */
export const getSectionWithItemsApiListsSectionsSectionIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetSectionWithItemsApiListsSectionsSectionIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetSectionWithItemsApiListsSectionsSectionIdGetResponse,
    GetSectionWithItemsApiListsSectionsSectionIdGetError,
    ThrowOnError
  >({
    url: '/api/lists/sections/{section_id}',
    ...options,
  })
}

/**
 * Update a section
 * Update a section.
 *
 * Args:
 * section_id: The ID of the section to update
 * updates: The fields to update
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * The updated section
 *
 * Raises:
 * HTTPException: If the section is not found or could not be updated
 */
export const updateSectionApiListsSectionsSectionIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSectionApiListsSectionsSectionIdPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateSectionApiListsSectionsSectionIdPutResponse,
    UpdateSectionApiListsSectionsSectionIdPutError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/sections/{section_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Create a section
 * Create a new section.
 *
 * Args:
 * section_data: The section data
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * The created section
 *
 * Raises:
 * HTTPException: If the section could not be created
 */
export const createSectionApiListsSectionsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateSectionApiListsSectionsPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateSectionApiListsSectionsPostResponse,
    CreateSectionApiListsSectionsPostError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/sections',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Bulk update list items
 * Bulk update list items in a section, primarily for reordering.
 *
 * Args:
 * bulk_update: The bulk update data containing section_id and item updates
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * Success message if all updates succeeded
 *
 * Raises:
 * HTTPException: If the section is not found, user doesn't have permission, or updates failed
 */
export const bulkUpdateListItemsApiListsItemsBulkPut = <ThrowOnError extends boolean = false>(
  options: Options<BulkUpdateListItemsApiListsItemsBulkPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, BulkUpdateListItemsApiListsItemsBulkPutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/items/bulk',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Create a list item
 * Create a new list item.
 *
 * Args:
 * item_data: The item data
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * The created item
 *
 * Raises:
 * HTTPException: If the item could not be created
 */
export const createListItemApiListsItemsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateListItemApiListsItemsPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateListItemApiListsItemsPostResponse,
    CreateListItemApiListsItemsPostError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/items',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Delete a list item
 * Delete a list item.
 *
 * Args:
 * item_id: The ID of the item to delete
 * current_user: Current authenticated user (from dependency)
 *
 * Raises:
 * HTTPException: If the item is not found or could not be deleted
 */
export const deleteListItemApiListsItemsItemIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteListItemApiListsItemsItemIdDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteListItemApiListsItemsItemIdDeleteResponse,
    DeleteListItemApiListsItemsItemIdDeleteError,
    ThrowOnError
  >({
    url: '/api/lists/items/{item_id}',
    ...options,
  })
}

/**
 * Update a list item
 * Update a list item.
 *
 * Args:
 * item_id: The ID of the item to update
 * updates: The fields to update
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * The updated item
 *
 * Raises:
 * HTTPException: If the item is not found or could not be updated
 */
export const updateListItemApiListsItemsItemIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateListItemApiListsItemsItemIdPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateListItemApiListsItemsItemIdPutResponse,
    UpdateListItemApiListsItemsItemIdPutError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/items/{item_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Create a highlight key
 * Create a new highlight key.
 *
 * Args:
 * highlight_data: The highlight data
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * The created highlight key
 *
 * Raises:
 * HTTPException: If the highlight key could not be created
 */
export const createHighlightKeyApiListsHighlightsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateHighlightKeyApiListsHighlightsPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    CreateHighlightKeyApiListsHighlightsPostResponse,
    CreateHighlightKeyApiListsHighlightsPostError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/highlights',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Delete a highlight key
 * Delete a highlight key.
 *
 * Args:
 * highlight_id: The ID of the highlight key to delete
 * current_user: Current authenticated user (from dependency)
 *
 * Raises:
 * HTTPException: If the highlight key is not found or could not be deleted
 */
export const deleteHighlightKeyApiListsHighlightsHighlightIdDelete = <ThrowOnError extends boolean = false>(
  options: Options<DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<
    DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteResponse,
    DeleteHighlightKeyApiListsHighlightsHighlightIdDeleteError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/highlights/{highlight_id}',
    ...options,
  })
}

/**
 * Update a highlight key
 * Update a highlight key.
 *
 * Args:
 * highlight_id: The ID of the highlight key to update
 * updates: The fields to update
 * current_user: Current authenticated user (from dependency)
 *
 * Returns:
 * The updated highlight key
 *
 * Raises:
 * HTTPException: If the highlight key is not found or could not be updated
 */
export const updateHighlightKeyApiListsHighlightsHighlightIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateHighlightKeyApiListsHighlightsHighlightIdPutData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UpdateHighlightKeyApiListsHighlightsHighlightIdPutResponse,
    UpdateHighlightKeyApiListsHighlightsHighlightIdPutError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/lists/highlights/{highlight_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Get public profiles with optional search
 * Get public profiles with optional search.
 *
 * Args:
 * search: Optional search query for display name
 * limit: Maximum number of profiles to return
 *
 * Returns:
 * List of public profiles
 */
export const getPublicProfilesApiUsersProfilesGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetPublicProfilesApiUsersProfilesGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetPublicProfilesApiUsersProfilesGetResponse,
    GetPublicProfilesApiUsersProfilesGetError,
    ThrowOnError
  >({
    url: '/api/users/profiles',
    ...options,
  })
}

/**
 * Get public profile by ID
 * Get a public profile by user ID.
 *
 * Args:
 * user_id: The ID of the user to retrieve
 *
 * Returns:
 * Public profile information
 *
 * Raises:
 * HTTPException: If the profile is not found or is private
 */
export const getPublicProfileApiUsersProfilesUserIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetPublicProfileApiUsersProfilesUserIdGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetPublicProfileApiUsersProfilesUserIdGetResponse,
    GetPublicProfileApiUsersProfilesUserIdGetError,
    ThrowOnError
  >({
    url: '/api/users/profiles/{user_id}',
    ...options,
  })
}

/**
 * Get current user's profile
 * Get the current user's profile.
 *
 * Returns:
 * Full profile information
 *
 * Raises:
 * HTTPException: If the profile is not found
 */
export const getMyProfileApiUsersMeGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetMyProfileApiUsersMeGetData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<GetMyProfileApiUsersMeGetResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users/me',
    ...options,
  })
}

/**
 * Update current user's profile
 * Update the current user's profile.
 *
 * Args:
 * profile_update: The profile data to update
 *
 * Returns:
 * Updated profile information
 *
 * Raises:
 * HTTPException: If the profile is not found
 */
export const updateMyProfileApiUsersMePatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMyProfileApiUsersMePatchData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<
    UpdateMyProfileApiUsersMePatchResponse,
    UpdateMyProfileApiUsersMePatchError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users/me',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })
}

/**
 * Upload user avatar
 * Upload an avatar image for the current user.
 *
 * Args:
 * file: The image file to upload (JPEG, PNG, or WebP)
 *
 * Returns:
 * Dictionary with avatar_url and message
 *
 * Raises:
 * HTTPException: If file validation fails or upload fails
 */
export const uploadAvatarApiUsersMeAvatarPost = <ThrowOnError extends boolean = false>(
  options: Options<UploadAvatarApiUsersMeAvatarPostData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<UploadAvatarApiUsersMeAvatarPostResponse, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/api/users/me/avatar',
    ...options,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
  })
}
